<img [src]="profilePicture" class="{{cssClass}}" alt="...">